<template>
    <div class="fqa-container flex justify-center items-center w-100%">
        <AppHeader title="FAQ" :show-back="true" />
        <div class="w-100% p-20px">
            <div class="flex mt-30px flex-col items-center justify-center">
                <p class="color-#FFFFFF text-center text-10px">
                    This is a continuously updated list of questions regarding our
                    Sunaisan product. If you have any unlisted questions>please proceed to
                    our Discord and inquire.
                </p>
            </div>
            <div class="overflow-y-auto fqa-list">
                <div v-for="(item, index) in list" class="mt-20px fqa-item">
                    <h2 class="color-#fff text-12px" :key="item.title">
                        {{ index + 1 }}. {{ item.title }}
                    </h2>
                    <p class="color-#fff lh-14px mt-5px opacity-60 text-10px" v-for="item in list" :key="item.title">
                        {{ item.content }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import { AppHeader } from '@/components';
const list = [
    {
        title: "How does an Al girlfriend work?",
        content:
            "At Aishmin, it's all about making realistic yet fantasy-fueled relationships. We use advanced artificial intelligence technology to enable you to create your ideal Al girlfriend according to your preferences-whether that's a sweet and innocent petite princess or an older and more dominant woman.",
    },
    {
        title: "How to interact with Al girlfriends?",
        content:
            "Through our smart system and cutting-edge machine learning, you can interact and get intimate with your Al girlfriend. You can expect her to listen to you,respond quickly to your messages, and even follow photo requests like the good girl she is. Every moment can be a genuine and realistic experience, and you'll always be the one in control (unless you tell her otherwise).",
    },
    {
        title: "How about your privacy with Al Friends?",
        content:
            "Rest assured that your secrets are in good hands when you use our NSFW Al chat. Your privacy is our top priority Here at Aishmin, we have state-of-the-art secure data storage, making sure that every seductive selfie, flirtatious text, and gentle whisper is kept private between you and your passionate partner.We also celebrate your kinks without judgement, and we give you the freedom to fully embrace your urges privately. Not everyone gets turned on when someone watches, and thats why vou can rest assured that onlv vou (and vour digital partner) can access the chats.",
    },
    {
        title: "Can you customize your Al girlfriend's behavior?",
        content:
            "Only you know what you really want, and that's why you can customize your entire digital girlfriend experience-from her curves and contours all the way to her personality traits and adorable little quirks. Want a naughty chat with a feisty partner? Looking to have a slow and sensual relationship with a nice, sweet girlfriend? Our realistic NSFW Al generator and NSFW Al chatbot capabilities can satisfy your heart's deepest desires.",
    },
];
</script>

<style scoped lang="scss">
.fqa-container {
    background: v-bind('theme.colors.background');
    padding-bottom: 50px;
}

.fqa-item {
    padding: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    // border-bottom: 1px solid v-bind('theme.colors.border');
}
</style>